import React from 'react';
import {Slider as NBSlider, ISliderProps} from 'native-base';

export const Slider = (props: ISliderProps) => {
  return(
    <NBSlider {...props}>
        <NBSlider.Track>
          <NBSlider.FilledTrack />
        </NBSlider.Track>
        <NBSlider.Thumb />
      </NBSlider>
  )
}